import { Dispatch, SetStateAction } from 'react';
import HousesAspects from '@/pages/HousesAspects';
import { SegmentedControl } from '@/components/ui/SegmentedControl';

interface WeeklyPredictionsTabsProps {
  activeWeek: 'current' | 'next';
  setActiveWeek: Dispatch<SetStateAction<'current' | 'next'>>;
}

const WeeklyPredictionsTabs = ({ activeWeek, setActiveWeek }: WeeklyPredictionsTabsProps) => {
  const handleTabChange = (week: 'current' | 'next') => {
    if (week === activeWeek) return;
    setActiveWeek(week);
  };

  return (
    <div className="space-y-6 relative flex flex-col items-center">
      <SegmentedControl
        options={[
          { label: 'Current Week', value: 'current' },
          { label: 'Next Week', value: 'next' },
        ]}
        value={activeWeek}
        onChange={(val) => handleTabChange(val as 'current' | 'next')}
      />

      <div className="w-full">
        <HousesAspects activeWeek={activeWeek} />
      </div>
    </div>
  );
};

export default WeeklyPredictionsTabs;
